import { ERROR_MESSAGE_AXIOS } from "./config"

export default {
   getMessageError: (code) => {
      return ERROR_MESSAGE_AXIOS[code] ? ERROR_MESSAGE_AXIOS[code] : "Có lỗi xảy ra vui lòng thử lại sau!";
   }
}